import { PasseriniAPI } from './apiService';

export type TemporaryLinkStatus = 'active' | 'revoked' | 'expired' | 'max_downloads_reached';

export interface TemporaryLinkListParams {
  status?: TemporaryLinkStatus;
  tramite_id?: number | string;
  date_from?: string;
  date_to?: string;
  page?: number;
}

export interface TemporaryLinkItem {
  id: string;
  token: string;
  url: string;
  fileName: string | null;
  tramiteId: number | string | null;
  expiresAt: string | null;
  maxDownloads: number | null;
  downloadCount: number;
  revoked: boolean;
  isActive: boolean;
  status: TemporaryLinkStatus;
  statusLabel: string;
  createdBy: {
    id: number;
    name: string;
  } | null;
  tramite: {
    id: number | string;
    numregistro: string | null;
    propiedad: string | null;
  } | null;
  createdAt: string;
}

export interface TemporaryLinksPaginatedResponse {
  data: TemporaryLinkItem[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
  links: Array<{
    url: string | null;
    label: string;
    active: boolean;
  }>;
}

export const temporaryLinksService = {
  async listTemporaryLinks(params: TemporaryLinkListParams = {}): Promise<TemporaryLinksPaginatedResponse> {
    const response = await PasseriniAPI.get('/temporary-links', { params });
    return response.data;
  },

  async revokeTemporaryLink(id: string): Promise<{ message: string }> {
    const response = await PasseriniAPI.delete(`/temporary-links/${id}`);
    return response.data;
  },

  async restoreTemporaryLink(id: string): Promise<{ message: string }> {
    const response = await PasseriniAPI.patch(`/temporary-links/${id}/restore`);
    return response.data;
  },
};

export default temporaryLinksService;
